package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCodeOfConductPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("CodeOfConduct.md", FrontMatterElement.Builder { addScalar("title", "Code of Conduct"); addScalar("subtitle", "行動規範"); addScalar("description", "KotlinFestはKotlinの技術情報の共有とコミュニケーションを目的としています。私たちはすべての参加者にとって安全で歓迎されるような場を作ることに努めます。…"); }))
}

@Page("/code-of-conduct")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun CodeOfConductPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("日本語")
        }
        org.jetbrains.compose.web.dom.Text(" / ")
        com.varabyte.kobweb.silk.components.navigation.Link("/code-of-conduct-en") {
            org.jetbrains.compose.web.dom.Text("English")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin FestはKotlinの技術情報の共有とコミュニケーションを目的としています。私たちはすべての参加者にとって安全で歓迎されるような場を作ることに努めます。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Festに参加するすべての人は下記の行動規範を守ることを求められます。主催者はこの行動規範をカンファレンス、パーティ、交流会に適用します。すべての人にとって安全な場所を提供するため、聴講者、登壇者、スポンサー、主催スタッフ含めたすべての参加者にご協力をお願いします。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("私たちは下記のような事柄に関わらずすべての人にとって安全な場を提供することに努めます。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("社会的あるいは法的な性、性自認、性表現（外見の性）、性指向")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("年齢、障がい、容姿、体格")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("人種、民族、宗教（無宗教を含む）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("技術の選択")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("そして下記のようなハラスメント行為をいかなる形であっても決して許容しません。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("脅迫、つきまとい、ストーキング")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("不適切な画像、動画、録音の再生（性的な画像など）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("発表や他のイベントに対する妨害行為")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("不適切な身体的接触")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("これらに限らない性的嫌がらせ")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("スポンサーや登壇者、主催スタッフもこのポリシーの対象となります。性的な言葉や画像はいかなる発表やワークショップ、パーティ、X( Twitter)のようなオンラインメディアにおいても不適切です。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("ハラスメント行為をやめるように指示された場合、直ちに従うことが求められます。ルールを守らない参加者は、主催者およびスポンサーの判断により、退場処分や今後のイベントに聴講者、登壇者、スタッフとして関わることを禁止します。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("もしハラスメントを受けていると感じたり、他の誰かがハラスメントされていることに気がついた場合、または他に何かお困りのことがあれば、すぐにスタッフまでご連絡ください。警備員や警察への連絡などを含め、安心してカンファレンスに参加できるようにお手伝いさせていただきます。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("この行動規範は、CC-BY-3.0で公開されている")
        com.varabyte.kobweb.silk.components.navigation.Link("https://nyc.droidcon.com/code-of-conduct/") {
            org.jetbrains.compose.web.dom.Text("Droidcon NYCのCode of Conduct")
        }
        org.jetbrains.compose.web.dom.Text(" および、")
        com.varabyte.kobweb.silk.components.navigation.Link("https://portal.droidkaigi.jp/about/code-of-conduct") {
            org.jetbrains.compose.web.dom.Text("DroidKaigiのCode of Conduct")
        }
        org.jetbrains.compose.web.dom.Text("を元に作成しています。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This work is licensed under a ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://creativecommons.org/licenses/by/3.0/deed.en_US") {
            org.jetbrains.compose.web.dom.Text("Creative Commons Attribution 3.0 Unported License")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Original source and credit: ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://2012.jsconf.us/#/about") {
            org.jetbrains.compose.web.dom.Text("http://2012.jsconf.us/#/about")
        }
        org.jetbrains.compose.web.dom.Text(" & ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://geekfeminism.wikia.com/wiki/Conference_anti-harassment/Policy") {
            org.jetbrains.compose.web.dom.Text("The Ada Initiative")
        }
    }
}
